import { h, Component } from 'preact';
import { sortObjectByOrder, joinClasses } from 'utils/utils';
import Transition from 'components/core/transition/transition';
import SimpleVideoPlayer from 'components/shared/simpleVideoPlayer/simpleVideoPlayer';
import { track } from 'utils/tracking';
import * as actions from 'store/actions';
import Store from 'store/store';
import s from 'components/templates/gallery/gallery.sss';
import HTML from 'components/core/html/html';
import { mod } from 'utils/math';

export default class Gallery extends Component {
	constructor(props) {
		super(props);
		this.next = this.navigate.bind(this, +1);
		this.prev = this.navigate.bind(this, -1);
		this.handlePosterClick = this.handlePosterClick.bind(this);

		this.state = {
			index: 0,
			playing: false
		};
	}

	componentDidMount() {
		super.componentDidMount?.();
		this.selectFromHash();
	}

	selectFromHash(hash = location.hash) {
		let [, selection] = hash.split('/');
		if (+selection) {
			this.navigateAbsolute(selection - 1);
		}
	}

	navigateAbsolute(index) {
		const list = Object.keys(this.props.data.list);
		list.forEach((video, idx) => {
			if (this[`$video${idx}`].$ytPlayer) {
				this[`$video${idx}`].pause();
			} else if (this[`$video${idx}`].$video) {
				this[`$video${idx}`].$video.pause();
			} else if (this[`$video${idx}`].$youtube) {
				this[`$video${idx}`].$youtube.pause();
			}

			this.setState({ [`playing${idx}`]: false });
		});
		this.setState({ index });
		track({ a: `gallery-image-${index}-click` });
	}

	navigate(offset) {
		const list = Object.keys(this.props.data.list);
		let newIndex = mod(this.state.index + offset, list.length);
		this.navigateAbsolute(newIndex);
	}

	getPosition(idx, activeIndex) {
		if (idx === activeIndex) {
			return s.active;
		}
		const length = Object.keys(this.props.data.list).length;
		if (idx === mod(activeIndex - 1, length)) {
			return s.left;
		}
		if (idx === mod(activeIndex + 1, length)) {
			return s.right;
		}
		if (length >= 5) {
			if (idx === mod(activeIndex - 2, length)) {
				return s.outLeft;
			}
			if (idx === mod(activeIndex + 2, length)) {
				return s.outRight;
			}
		}
		return s.inactive;
	}

	paragraph(item) {
		if (!item.title && !item.text) return;
		return (
			<div class={s.paragraph} id={item.title}>
				{item.title && <HTML tag="h3" markdown class={s.title}>{item.title}</HTML>}
				{item.text && <p class={s.text}>{item.text}</p>}
			</div>
		);
	}

	handlePosterClick(idx, title, file, youtubeId) {
		const video = youtubeId ? this[`$video${idx}`] : this[`$video${idx}`]?.$video;
		if (this.state[`playing${idx}`]) {
			video.pause();
		} else {
			video.play();
			!youtubeId && Store.emit(actions.NETFLIX_GALLERY_ITEM_CLICK, 'content-carousel', title, file);
		}
		this.setState({
			[`playing${idx}`]: !this.state[`playing${idx}`]
		});
	}

	render({ data, isDesktop, active }, { index }) {
		const {
			list,
			title
		} = data;

		const sortedList = sortObjectByOrder(list);
		const length = sortedList.length;
		const activeItem = sortedList[index];

		return (
			<div class={joinClasses(s.wrapper, active && s.active)} id="gallery" data-section-observed>
				{title && <h3 class={s.title}>{title}</h3>}
				<Transition
					class={s.transition}
					enteringClass={s.entering}
					emptyClass={s.empty}
					visibleClass={s.visible}
					leavingClass={s.leaving}
					duration={1000}
				>
					{this.paragraph(activeItem)}
				</Transition>
				<div class={s.view}>
					{sortedList.map((item, idx) => {
						const position = this.getPosition(idx, index);
						if (item.src.includes('.mp4')) {
							return (
								<div class={joinClasses(s.relCont, position, s.videoWrapper)} inert={idx !== index}>
									<SimpleVideoPlayer
										class={s.video}
										src={item.src}
										showControls
										ref={ref => this[`$video${idx}`] = ref}
									/>
									<div class={joinClasses(s.playBtn, !this.state[`playing${idx}`] ? s.show : s.hide)} />
									<div class={joinClasses(s.poster, !this.state[`playing${idx}`] ? s.show : s.hide)} style={{ backgroundImage: `url(${item.poster})` }} onClick={() => this.handlePosterClick(idx, title, item.src)} />
								</div>
							);
						}
						return (
							<img src={item.src} class={joinClasses(s.item, position)} />
						);

					})}
					{length > 1 && (
						<div class={s.controls}>
							<button class={joinClasses(s.btn, s.left)} onClick={this.prev}>{!isDesktop && 'Prev'}</button>
							<div class={s.indicator}>{`${index + 1}/${length}`}</div>
							<button class={joinClasses(s.btn, s.right)} onClick={this.next}>{!isDesktop && 'Next'}</button>
						</div>
					)}
				</div>
			</div>
		);
	}
}
